export const s3_url = "https://jakartalabs.s3.ap-southeast-1.amazonaws.com/";
